import { useMutation } from 'react-query'

import type { TrendDetectionService } from 'features/trend-detection/service/service'
import type { InterpretFiltersResponse } from 'features/trend-detection/types'

export interface UseInterpretFiltersParams {
  service: TrendDetectionService
  projectId: string | null
}

export interface UseInterpretFiltersResult {
  runInterpret: (prompt: string) => Promise<InterpretFiltersResponse>
  isInterpreting: boolean
}

export function useInterpretFilters({
  service,
  projectId,
}: UseInterpretFiltersParams): UseInterpretFiltersResult {
  const mutation = useMutation({
    mutationFn: async (prompt: string) => {
      if (!projectId) throw new Error('No project selected')
      return service.interpretFilters(projectId, prompt)
    },
  })

  return {
    runInterpret: async (prompt: string) => mutation.mutateAsync(prompt),
    isInterpreting: mutation.isLoading,
  }
}
